import React from 'react'
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import List from '../../list/list'
import ListExpandable from '../../list/list-expandable'
import Text from '../../form/form-text'
import DatePicker from '../../form/form-date-time-picker'
import Select from '../../form/form-select'

class ModuleTvGridMeta extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            data: this.props,
            disabled: this.props.disabled
        }
        this.i18n = 'app.modules.components.'
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextState) {
        this.setState({disabled: nextProps.disabled})
    }

    render() {
        let { day, liveButtonName, liveTeaser, replayButtonName, title } = this.state.data;
        let { disabled } = this.state;

        return <div className="module-tvGridMeta">

            <DatePicker disabdayled={disabled} label={'app.day'} date={day?new Date(day):new date()} />
            <Text disabled={disabled} label={'app.title'} value={title} />
            <Text disabled={disabled} label={this.i18n + 'liveButtonName'} value={liveButtonName} />
            <Text disabled={disabled} label={this.i18n + 'liveTeaser'} value={liveTeaser} />
            <Text disabled={disabled} label={this.i18n + 'replayButtonName'} value={replayButtonName} />

        </div>;
    }
}

ModuleTvGridMeta.propTypes = {
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool, // souhld be .isRequired,
    isCustom: PropTypes.bool, // souhld be .isRequired,
    day: PropTypes.string,
    liveButtonName: PropTypes.string,
    liveTeaser: PropTypes.string,
    replayButtonName: PropTypes.string,
    title: PropTypes.string,
}

export default ModuleTvGridMeta;

